module.exports = {"myNavButtons":"_src_components_NavButtons_NavButtons__myNavButtons"}